import * as Yup from "yup";

const DepartmentValidation = Yup.object().shape({
  department: Yup.string().required("Required"),
});

export default DepartmentValidation;
